export default __webpack_public_path__ + "static/Carmen Hidalgo-8cb86be2de559236ada422e61f26da1f.jpg";